import 'core-js/stable';
import 'regenerator-runtime/runtime';
import 'isomorphic-fetch';

import * as React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import Main from './app/containers/Main';

const container = document.getElementById('app');
if (!container) {
  throw new Error('Root element #app not found');
}
const root = createRoot(container);
root.render(
  <BrowserRouter>
    <Main />
  </BrowserRouter>,
);
